import React from 'react';
import { LegalPage, LegalSection } from '../components/LegalPage';
export function Privacy() {
  return <LegalPage title="Privacy Policy" lastUpdated="7 June 2026" data-id="element-1018">
      <p data-id="element-1019">
        Masube Settle (Pty) Ltd ("Masube", "we", "us") is committed to
        protecting your personal information in line with the Protection of
        Personal Information Act, 2013 (POPIA). This policy explains what we
        collect, why we collect it, and the choices you have.
      </p>

      <LegalSection heading="1. Information we collect" data-id="element-1020">
        <p data-id="element-1021">
          When you join our waitlist or book a demo, we collect your name, work
          email, company name, industry vertical, and approximate account-book
          size. For retailers using the platform, we process transaction
          metadata (amount, channel, status, timestamps) on behalf of the
          retailer as an operator under POPIA.
        </p>
        <p data-id="element-1022">
          We do <strong data-id="element-1023">not</strong> collect cardholder data, banking PINs, or
          one-time passwords from end customers. Payments are authorised
          directly through PayShap and the customer's own bank.
        </p>
      </LegalSection>

      <LegalSection heading="2. How we use your information" data-id="element-1024">
        <p data-id="element-1025">
          We use your information to operate the waitlist, contact you about
          early access and demos, provide and improve the service, and meet our
          legal and regulatory obligations as a payment orchestration provider.
        </p>
      </LegalSection>

      <LegalSection heading="3. Sharing & processors" data-id="element-1026">
        <p data-id="element-1027">
          We share information only with sub-processors necessary to deliver the
          service (such as hosting, email, and settlement partners), all bound
          by appropriate data-processing terms. We never sell your personal
          information.
        </p>
      </LegalSection>

      <LegalSection heading="4. Data retention & security" data-id="element-1028">
        <p data-id="element-1029">
          We retain personal information only as long as necessary for the
          purposes described here or as required by law. Data is encrypted in
          transit and at rest, and access is restricted on a need-to-know basis.
        </p>
      </LegalSection>

      <LegalSection heading="5. Your rights" data-id="element-1030">
        <p data-id="element-1031">
          Under POPIA you may request access to, correction of, or deletion of
          your personal information, and you may object to processing. To
          exercise these rights, contact our Information Officer at{' '}
          <a href="mailto:privacy@masube.co.za" className="text-mint hover:underline" data-id="element-1032">
            
            privacy@masube.co.za
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection heading="6. Changes to this policy" data-id="element-1033">
        <p data-id="element-1034">
          We may update this policy from time to time. Material changes will be
          communicated via the email you provided or posted on this page with a
          revised "last updated" date.
        </p>
      </LegalSection>
    </LegalPage>;
}